import "../styles/services.css";


import serviceBg from "../assets/images/serbg.jpg";

function Services() {

  const services = [
    {
      title: "Hearing Assessment",
      description:
        "Comprehensive hearing evaluation using advanced diagnostic equipment to accurately assess hearing ability."
    },
    {
      title: "Hearing Aid Trial",
      description:
        "Experience different hearing aids before purchasing to find the most comfortable and effective solution."
    },
    {
      title: "Hearing Aid Fitting",
      description:
        "Professional fitting and fine tuning to ensure maximum comfort and optimal hearing performance."
    },
    {
      title: "Hearing Aid Programming",
      description:
        "Digital programming and personalized adjustments based on your hearing profile."
    },
    {
      title: "Hearing Aid Repair",
      description:
        "Fast repair and maintenance services to keep your hearing aids functioning efficiently."
    },
    {
      title: "Ear Mould",
      description:
        "Custom ear moulds designed for comfort, better sound quality and long-term usage."
    },
    {
      title: "Home Visit",
      description:
        "Professional hearing care services available at your home for elderly and special patients."
    },
    {
      title: "Consultation",
      description:
        "Expert guidance from experienced audiologists to choose the best hearing solution."
    }
  ];

  return (
    <>

      {/* Hero */}

      <section
        className="services-hero" data-aos="fade-up"
        style={{ backgroundImage: `url(${serviceBg})` }}
      >

        <div className="services-overlay">

          <div className="hero-content">

            <h1>Our Services</h1>

            <p>
              Complete Hearing Care Solutions with Professional Audiologists
              and Advanced Hearing Technology.
            </p>

          </div>

        </div>

      </section>

      {/* Intro */}

      <section className="services-intro">

        <h2>Professional Hearing Healthcare</h2>

        <p>
          At Jagadish Hearing Aids, we provide end-to-end hearing healthcare
          services designed to improve your hearing experience and quality of
          life.
        </p>

      </section>

      {/* Cards */}

      <section className="services-grid">

        {services.map((service, index) => (

          <div
            className="service-card"
            key={index}
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay={index * 150}
          >

            <div className="service-number">
              {String(index + 1).padStart(2, "0")}
            </div>

            <h3>{service.title}</h3>

            <p>{service.description}</p>

          </div>

        ))}


      </section>
      {/* ================= Why Choose Us ================= */}

      <section className="why-services">

        <div className="why-heading">

          <h2>Why Choose Our Services?</h2>

          <p>
            We combine decades of experience, advanced technology, and
            personalized care to deliver the best hearing healthcare
            experience.
          </p>

        </div>

        <div className="why-grid">

          <div
            className="why-card"
            data-aos="zoom-in"
            data-aos-duration="900"
            data-aos-delay="0"
          >
            <h3>35+ Years Experience</h3>
            <p>Trusted hearing healthcare provider serving thousands of satisfied patients.</p>
          </div>

          <div
            className="why-card"
            data-aos="zoom-in"
            data-aos-duration="900"
            data-aos-delay="200"
          >
            <h3>Certified Audiologists</h3>
            <p>Experienced professionals providing accurate diagnosis and personalized hearing solutions.</p>
          </div>

          <div
            className="why-card"
            data-aos="zoom-in"
            data-aos-duration="900"
            data-aos-delay="400"
          >
            <h3>Latest Technology</h3>
            <p>Advanced diagnostic equipment and digital hearing aid programming for better results.</p>
          </div>

          <div
            className="why-card"
            data-aos="zoom-in"
            data-aos-duration="900"
            data-aos-delay="600"
          >
            <h3>Lifetime Support</h3>
            <p>Continuous follow-up, maintenance, servicing, and expert guidance whenever you need us.</p>
          </div>

        </div>

      </section>

      {/* ================= CTA ================= */}



    </>
  );
}

export default Services;